import Axios from "axios";

const state = {
  cart: [],
  baseUrl: "https://baas.ketabbaaz.com",
  cartItems: [],
  isLoading: false,
  productIndexInCart: -1,
};
const getters = {
  cartItems: (state) => {
    return state.cart;
  },
};
const actions = {
  async getCartData({commit}, payload) {
    commit('changeLoading', true);
    // state.cart = [];
 
    if (localStorage.getItem('shopToken')) {
      await Axios.get(
        state.baseUrl + "/onlineShop/cart/getData/" + payload.cartId,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          commit('setCart', res.data.items);
          // if(this.$route.path.search('productDetails')>0){
          //   // commit('inCart', -1);
          // }
          if (payload.id) {
            if (state.cart && state.cart.length) {
              let index = state.cart.findIndex((x) => x.id === payload.id);
           
              if (index > -1) {
                commit('inCart', index);
              } else {
                commit('inCart', -1);
              }
            }
          } else {
            commit('inCart', -1);
          }
          // if (this.cart.length === 0) {
            // this.isEmpty = true;
          // }
          commit('changeLoading', false);

        })
        .catch((err) => {
       
          commit('changeLoading', false);
          if ((err.response.status == 403) || (err.response.status == 404))
            localStorage.setItem("name", "");
          else this.toast("خطا: " + err.response.data, "error");
        });
    }
  },
  addToCart({commit}, payload) {
    commit('addItem', payload.product);
  },
  removeCartItems({commit}){
    state.cart=[];
  },

};
const mutations = {
  setInCart: (state, name) => {
    state.cartItems = name;
  },
  changeLoading(state, loading) {
    state.isLoading = loading;
  },
  setCart(state, value) {
  
    state.cart = value;

  },
  addItem(state, value) {
    state.cart.push(value);
  },
  inCart(state, value) {
    state.productIndexInCart = value;
  }
};
export default {
  state,
  actions,
  getters,
  mutations,
};
